import { render, staticRenderFns } from "./AppBox.vue?vue&type=template&id=5e9bf05e&scoped=true&"
import script from "./AppBox.vue?vue&type=script&lang=ts&"
export * from "./AppBox.vue?vue&type=script&lang=ts&"
import style0 from "./AppBox.vue?vue&type=style&index=0&id=5e9bf05e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9bf05e",
  null
  
)

export default component.exports